import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.scrollIntoView({
      behavior: "smooth",
      block: "center",
    })
    this.application.removeController(this)
    delete this.element.dataset.controller
  }
}
